import { Component, OnInit, Input } from '@angular/core'

import { IScoreProgressBarConfig } from './'

const DEFAULTS = Object.freeze({
  THICKNESS: '30px',
  PASSING_COLOR: '#61c46e',
  FAILING_COLOR: '#fcb040'
})

@Component({
  selector: 'mp-score-progress-bar',
  templateUrl: './score-progress-bar.html',
  styleUrls: ['./score-progress-bar.scss']
})
export class ScoreProgressBarComponent implements OnInit {
  @Input() public config: IScoreProgressBarConfig

  public get backgroundColor(): string {
    return this._isPassingScoreReached() ? this.config.passingColor : this.config.failingColor
  }

  public get score(): string {
    return `${this.config.score}%`
  }

  public get isPassingTextEnabled(): boolean {
    return this.config.isPassingTextEnabled && !this._isPassingScoreReached()
  }

  public ngOnInit() {
    this.config.thickness = this.config.thickness || DEFAULTS.THICKNESS
    this.config.passingColor = this.config.passingColor || DEFAULTS.PASSING_COLOR
    this.config.failingColor = this.config.failingColor || DEFAULTS.FAILING_COLOR
  }

  private _isPassingScoreReached(): boolean {
    return this.config.score >= this.config.passingScore
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/score-progress-bar/score-progress-bar.component.ts